<template>
<div id="page-signin">
    <img class="banner" src="api/1/banner">
    <form role="form" id="sign-in-form" method="post" action="/api/1/sessions/signin">

        <article>
            <div class="avatar">
                <img src="/api/1/logo">
            </div>
            <span id="sos-url">{{ sosTitle }}</span>
        </article>

        <section>
            <input type="text" placeholder="Username" name="user" id="signin_user" />

            <input type="password" placeholder="Password" name="pass" id="signin_pass" />
        </section>

        <section>
            <button type="submit">Sign In</button>
            <a href="/access"><u>New User</u></a>
        </section>

    </form>

    <a v-if="serverInfo.sso_type=='azure_ad'" href="/azure" class="sso-link" title="Microsoft Azure Sign-in"><img src="img/icon-microsoft.png" />Sign in with Microsoft</a>
    <a v-if="serverInfo.sso_type=='okta'" href="/redirect/okta" class="sso-link" title="Okta Sign-in"><img src="img/icon-okta.png" />Sign in with Okta</a>

    <div class="legal">
        <small><b>Attention</b>: This page is for authorized users only.
            Unauthorized access is prohibited by law. If you visited this
            page in error please close your browser immediately.</small>
    </div>

    <a v-if="serverInfo.smtp&&serverInfo.sso_type==''" href="/reset" class="forgot-password">Forgot Password?</a>

</div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import {
    mapGetters
} from "vuex";
export default {

    name: "Signin",

    data() {
        return {
            username: "",
            password: "",
        }
    },

    created() {
        this.$store.dispatch("loadPublicServerInfo")
    },

    computed: {
        ...mapGetters(["serverInfo", "sosTitle"])
    },

}
</script>

<style lang="less">
@import "@/assets/less/style.less";

//these two styles are to prevent the scrollbar from shifting the content of the page
html {
    width: 100vw;
}

body {
    overflow-x: hidden;
}

.sso-link {
    display: flex;
    align-items: center;
    text-decoration: none;

    &:hover {
        text-decoration: none;
    }

    //padding: 6px 12px;

    margin-bottom: 1.5em;

    img {
        height: 2.4em;
        width: auto;
        margin-right: .5em;
        margin-bottom: 0;
        margin-top: 0;
    }

}

#page-signin {

    .make-col(10);
    .make-col-offset(1);
    padding-top: 1rem;

    .avatar {
        border: none;
        border-radius: .5em;
    }

    .banner {
        margin-bottom: 1.5em;
        border-radius: var(--radius-2);
        box-shadow: var(--shadow-1);
        height: auto;
    }

    #sign-in-form {

        margin-bottom: 1.5em;

        .avatar {
            margin-right: 1em;
        }

        article {
            margin-bottom: 1.5em;
            display: flex;
            align-items: center;
        }

        input {
            margin-bottom: 1em;
            &:last-of-type
            {
                margin-bottom: 1.5rem;
            }
        }

        button {
 
            border: none;
            background-color: var(--color-blue-7);
            color: var(--body-bg);
            margin-right: 1em;

            &:hover {
                background-color: var(--color-blue-8);
            }

        }

        a:link {
            color: var(--color-black);
        }
    }

    .legal {
        margin-bottom: 1rem;
        color: var(--color-gray-8);
    }

    .forgot-password
    {
        font-size: .75em;
    }

    @media @breakpoint-sm-up {
        padding-top: 4rem;
        .make-col(6);
        .make-col-offset(3);
    }

    @media @breakpoint-lg-up {
        .make-col(4);
        .make-col-offset(4);
    }
    @media@breakpoint-xxl-up {
        .make-col(2.5);
        .make-col-offset(4.75);
    }
    
}
</style>
